export default __webpack_public_path__ + "static/media/call_ico.5b52c449.svg";